export const images = {
  animal_lover: require("../assets/images/animal_lover.avif"),
  puppy: require("../assets/images/cute_puppy.avif"),
  horse: require("../assets/images/horse.avif"),
  man_buyer: require("../assets/images/man_buyer.avif"),
  horse_with_woman: require("../assets/images/horse_with_woman.avif"),
  puppy_with_woman: require("../assets/images/puppy_with_woman.avif"),
  animal_group: require("../assets/images/animal_group.avif"),

  logo: require("../assets/images/logo.svg").default,
  dark_logo: require("../assets/images/dark_logo.svg").default,

  man_buyer_small: require("../assets/images/man_buyer_small.svg").default,

  search: require("../assets/images/search.svg").default,
  choose: require("../assets/images/choose.svg").default,
  contact: require("../assets/images/contact.svg").default,

  easy_search: require("../assets/images/easy_search.svg").default,
  verified_breeders: require("../assets/images/verified_breeders.svg").default,
  wide_selection: require("../assets/images/wide_selection.svg").default,

  white_right_arrow: require("../assets/images/white_right_arrow.svg").default,
  bottom_arrow: require("../assets/images/bottom_arrow.svg").default,

  pinterest: require("../assets/images/pinterest.svg").default,
  instagram: require("../assets/images/instagram.svg").default,
  facebook: require("../assets/images/facebook.svg").default,
  youtube: require("../assets/images/youtube.svg").default,
} as const;

export default images;
